import { jsonApi } from '../http-request';

export const SET_HOME_SERVICES_OFFERS = 'SET_HOME_SERVICES_OFFERS';
export const SET_HOME_SERVICES_PROPERTY_CONFIG =
  'SET_HOME_SERVICES_PROPERTY_CONFIG';

export const actions = {
  ...jsonApi.createUpdResourceFacade('home_services'),
  setHomeServicesOffers: payload => ({
    type: SET_HOME_SERVICES_OFFERS,
    payload,
  }),
  setHomeServicesPropertyConfig: payload => ({
    type: SET_HOME_SERVICES_PROPERTY_CONFIG,
    payload,
  }),
};
